import { FormattedMessage } from "react-intl";
import { BsFiletypeDocx, BsFiletypeDoc, BsFiletypePdf, BsFileExcel, BsFiletypeXml } from "react-icons/bs";

export const BASE_URL = process.env.REACT_APP_BASE_URL
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL

export const DATE_FORMAT_SERVER = "yyyy-MM-dd";
export const DATE_FORMAT_DISPLAY = "dd/MM/yyyy";
export const DATETIME_FORMAT_DISPLAY = "dd/MM/yyyy HH:mm";
export const TIME_FORMAT_DISPLAY = "hh:mm a";
export const ACCESS_TOKEN = "influencee_access_user";


export const ROLE_ADMIN = {
    value: "super-admin",
    label: <FormattedMessage id="super_admin" defaultMessage={"Super Admin"} />,
}


export const APP_VERSION = "v0.0.1"

export const POPUP_SMALL = "small";
export const POPUP_MEDIUM = "medium";
export const POPUP_LARGE = "large";
export const POPUP_TYPE_SIDE = "side";
export const POPUP_TYPE_DEFAULT = "default";


export const BOT_USER = "AI Chatbot"

export const initialPopupState = {
    size: POPUP_MEDIUM,
    heading: "",
    hideDefaultClose: false,
    contained: true,
    component: null,
    type: "default"
};

export const LANGUAGE_ACCESS = "incluencee_lang"
export const EN = "en"
export const IT = "it"

export const OPTION_YES = {
    value: true,
    label: <FormattedMessage id="yes" defaultMessage={"Yes"} />,
    label: "Yes"
}
export const OPTION_NO = {
    value: false,
    label: <FormattedMessage id="no" defaultMessage={"No"} />,
}

export const OPTIONS_BOOL = [
    OPTION_YES,
    OPTION_NO
]

export const ASSENDING_ORDER = "asc"
export const DESENDING_ORDER = "desc"
export const ORDER_DESCENDING = {
    value: "desc",
    label: <FormattedMessage id="most_recent" defaultMessage={"Most Recent"} />,
}
export const ORDER_ASCENDING = {
    value: "asc",
    label: <FormattedMessage id="least_recent" defaultMessage={"Least Recent"} />,
}

export const SORT_ORDERS = [
    ORDER_DESCENDING,
    ORDER_ASCENDING
]
export const LISTING_LIMIT = 12;

// export const ACCEPTED = "accepted"
// export const APPROVED = "approved"
// export const PENDING = "pending"
// export const REJECTED = "rejected"

// export const AGENCY_ACCEPTED = "agency-accepted"
// export const INFLUENCER_REJECTED = "influencer-rejected"
// export const AGENCY_REJECTED = "agency-rejected"


export const STATUS_APPROVED = {
    value: "approved",
    label: <FormattedMessage id="approved" defaultMessage={"Approved"} />,
    backgroundColor: "bg-emerald-500",
    textColor: "text-white",
}
export const STATUS_PRIVATE = {
    value: "private",
    label: <FormattedMessage id="private" defaultMessage={"Private"} />,
    backgroundColor: "bg-secondary",
    textColor: "text-white",
}
export const STATUS_PUBLIC = {
    value: "public",
    label: <FormattedMessage id="public" defaultMessage={"Public"} />,
    backgroundColor: "bg-primary",
    textColor: "text-white",
}

export const STATUS_INFLUENCER_REJECTED = {
    value: "influencer-rejected",
    label: <FormattedMessage id="rejected" defaultMessage={"Rejected"} />,
    backgroundColor: "bg-red-500",
    textColor: "text-white",
}
export const STATUS_AGENCY_REJECTED = {
    value: "agency-rejected",
    label: <FormattedMessage id="rejected" defaultMessage={"Rejected"} />,
    backgroundColor: "bg-red-500",
    textColor: "text-white",
}

export const STATUS_AGENCY_ACCEPTED = {
    value: "agency-accepted",
    label: <FormattedMessage id="accepted" defaultMessage={"Accepted"} />,
    backgroundColor: "bg-emerald-500",
    textColor: "text-white",
}

export const STATUS_INFLUENCER_ACCEPTED = {
    value: "influencer-accepted",
    label: <FormattedMessage id="in-review" defaultMessage={"In Review"} />,
    backgroundColor: "bg-violet-500",
    textColor: "text-white",
}

export const STATUS_ACCEPTED = {
    value: "accepted",
    label: <FormattedMessage id="accepted" defaultMessage={"Accepted"} />,
    backgroundColor: "bg-emerald-500",
    textColor: "text-white",
}
export const STATUS_COMPLETED = {
    value: "complete",
    label: <FormattedMessage id="completed" defaultMessage={"Completed"} />,
    backgroundColor: "bg-primary",
    textColor: "text-white",
}

export const STATUS_STOPPED = {
    value: "stop",
    label: <FormattedMessage id="stopped" defaultMessage={"Stopped"} />,
    backgroundColor: "bg-secondary",
    textColor: "text-white",
}
export const STATUS_CLOSED = {
    value: "complete",
    label: <FormattedMessage id="closed" defaultMessage={"Closed"} />,
    backgroundColor: "bg-secondary",
    textColor: "text-white",
}
export const STATUS_STARTED = {
    value: "start",
    label: <FormattedMessage id="started" defaultMessage={"Started"} />,
    backgroundColor: "bg-primary",
    textColor: "text-white",
}
export const STATUS_PENDING = {
    value: "pending",
    label: <FormattedMessage id="pending" defaultMessage={"Pending"} />,
    backgroundColor: "bg-yellow-500",
    textColor: "text-white",
}
export const STATUS_REJECTED = {
    value: "rejected",
    label: <FormattedMessage id="rejected" defaultMessage={"Rejected"} />,
    backgroundColor: "bg-red-500",
    textColor: "text-white",
}

export const INVITE_STATUSES = [
    // STATUS_ACCEPTED,
    STATUS_PENDING,
    // STATUS_REJECTED,
    STATUS_INFLUENCER_ACCEPTED,
    STATUS_AGENCY_ACCEPTED,
    // STATUS_INFLUENCER_REJECTED,
    // STATUS_AGENCY_REJECTED,
]


export const USER_ACTIVE = {
    value: "active",
    label: <FormattedMessage id="active" defaultMessage={"Active"} />,
}
export const USER_PENDING = {
    value: "pending",
    label: <FormattedMessage id="pending" defaultMessage={"Pending"} />,
}
export const USER_DISABLED = {
    value: "disabled",
    label: <FormattedMessage id="disabled" defaultMessage={"Disabled"} />,
}

export const USER_STATUS = [
    USER_ACTIVE,
    USER_PENDING,
    USER_DISABLED
]

export const ACTIVE = {
    value: "true",
    label: <FormattedMessage id="active" defaultMessage={"Active"} />,
}
export const DISABLED = {
    value: "false",
    label: <FormattedMessage id="disabled" defaultMessage={"Disabled"} />,
}

export const IS_ACTIVE = [
    ACTIVE,
    DISABLED
]

export const APP_LANGUAGE = "influencee_lang";

export const LANGUAGE_OPTIONS = [
    {
        value: {
            code: "en",
            language: "English"
        },
        label: <>
            <div className="flex items-center justify-start gap-2">
                <img src="/images/flags/us.png" alt="English" className="h-6 w-6" />
                <p className="font-semibold">- EN</p>
            </div></>
    },
    {
        value: {
            code: "it",
            language: "Italian",
        },
        label: <>
            <div className="flex items-center justify-start gap-2">
                <img src="/images/flags/it.png" alt="Italian" className="h-6 w-6" />
                <p className="font-semibold">- IT</p>
            </div>
        </>
    },
    // {
    //     value: {
    //         code: "zh-hans",
    //         language: "简体中文"
    //     },
    //     label: <>
    //         <div className="flex items-center justify-start gap-2">
    //             <img src="/images/flags/cn.png" alt="Chinese" className="h-6 w-6" />
    //             <p className="font-semibold">- CN</p>
    //         </div>
    //     </>
    // },
]

export const TICKETS_VIEW_NOT_SELECTED = "not-selected"


export const FILE_PDF = "PDF"
export const FILE_XML = "XML"
export const FILE_IMAGE = "IMAGE"
export const FILE_EXCEL = "EXCEL";
export const FILE_WORD = "WORD";

export const SUPPORTED_FILE_FORMATS = [
    { extension: 'pdf', value: FILE_PDF, Icon: BsFiletypePdf },
    { extension: 'xml', value: FILE_XML, Icon: BsFiletypeXml },
    { extension: 'png', value: FILE_IMAGE },
    { extension: 'jpg', value: FILE_IMAGE },
    { extension: 'jpeg', value: FILE_IMAGE }, // Support both .jpg and .jpeg
    { extension: 'xls', value: FILE_EXCEL, Icon: BsFileExcel },  // Excel format
    { extension: 'xlsx', value: FILE_EXCEL, Icon: BsFileExcel }, // Excel format
    { extension: 'doc', value: FILE_WORD, Icon: BsFiletypeDoc },   // Word format
    { extension: 'docx', value: FILE_WORD, Icon: BsFiletypeDocx }  // Word format
];

export const EMAIL_REGX = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/



export const TYPE_INFLUENCER = "influencer"
export const TYPE_AGENCY = "agency"


export const INSTAGRAM = "instagram"
export const TIKTOK = "tiktok"

export const CONTENT_POST = {label: <FormattedMessage id="instagram_post" defaultMessage={"Instagram Post"} />, value: "instagram-post" , platform: INSTAGRAM}
export const CONTENT_VIDEO = {label: <FormattedMessage id="tiktok_video" defaultMessage={"TikTok Video"} />, value: "tiktok-video" , platform: TIKTOK}
export const CONTENT_REEL = {label: <FormattedMessage id="instagram_reel" defaultMessage={"Instagram Reel"} />, value: "instagram-reel" , platform: INSTAGRAM}
export const CONTENT_STORY = {label: <FormattedMessage id="instagram_story" defaultMessage={"Instagram Story"} />, value: "instagram-story" , platform: INSTAGRAM}
export const CONTENT_REEL_STORY = {label: <FormattedMessage id="instagram_reel_story" defaultMessage={"Instagram Reel + Story"} />, value: "instareel_story" , platform: INSTAGRAM}




export const CONTENT_TYPE = [
    CONTENT_POST,
    CONTENT_REEL,
    CONTENT_STORY,
    CONTENT_REEL_STORY,
    CONTENT_VIDEO,
]
 
export const PLATFORMS = [
    {
        label: <FormattedMessage id="instagram" defaultMessage={"Instagram"} />,
        value: INSTAGRAM,
    },
    {
        label: <FormattedMessage id="tiktok" defaultMessage={"TikTok"} />,
        value: TIKTOK,
    }
]


export const CATEGORIES = [
    {
        label: <FormattedMessage id="actor" defaultMessage={"Actor"} />,
        // label: "Actor",
        value: "actor"
    },
    {
        label: <FormattedMessage id="architect" defaultMessage={"Architect"} />,
        // label: "Architect",
        value: "architect"
    },
    {
        label: <FormattedMessage id="artist" defaultMessage={"Artist"} />,
        value: "artist"
    },
    {
        label: <FormattedMessage id="beauty" defaultMessage={"Beauty"} />,
        value: "beauty"
    },
    {
        label: <FormattedMessage id="comic" defaultMessage={"Comic"} />,
        value: "comic"
    },
    {
        label: <FormattedMessage id="content_creator" defaultMessage={"Content creator"} />,
        value: "content_creator"
    },
    {
        label: <FormattedMessage id="fashion" defaultMessage={"Fashion"} />,
        value: "fashion"
    },
    {
        label: <FormattedMessage id="food" defaultMessage={"Food"} />,
        value: "food"
    },
    {
        label: <FormattedMessage id="photographer" defaultMessage={"Photographer"} />,
        value: "photographer"
    },
    {
        label: <FormattedMessage id="health_n_fitness" defaultMessage={"Health and Fitness"} />,
        value: "health_n_fitness"
    },
    {
        label: <FormattedMessage id="entrepreneur" defaultMessage={"Entrepreneur"} />,  
        value: "entrepreneur"
    },
    {
        label: <FormattedMessage id="lifestyle" defaultMessage={"Lifestyle"} />,
        value: "lifestyle"
    },
    {
        label: <FormattedMessage id="luxury" defaultMessage={"Luxury"} />,
        value: "luxury"
    },
    {
        label: <FormattedMessage id="parenting" defaultMessage={"Parenting"} />,
        value: "parenting"
    },
    {
        label: <FormattedMessage id="marketing" defaultMessage={"Marketing"} />,
        value: "marketing"
    },
    {
        label: <FormattedMessage id="medical" defaultMessage={"Medical"} />,
        value: "medical"
    },
    {
        label: <FormattedMessage id="model" defaultMessage={"Model"} />,
        value: "model"
    },
    {
        label: <FormattedMessage id="music" defaultMessage={"Music"} />,
        value: "music"
    },
    {
        label: <FormattedMessage id="public_figure" defaultMessage={"Public Figure"} />,
        value: "public_figure"
    },
    {
        label: <FormattedMessage id="pets_and_animals" defaultMessage={"Pets and Animals"} />,
        value: "pets_and_animals"
    },
    {
        label: <FormattedMessage id="shopping_retail" defaultMessage={"Shopping and Retail"} />,
        value: "shopping_retail"
    },
    {
        label: <FormattedMessage id="sport" defaultMessage={"Sport"} />,
        value: "sport"
    },
    {
        label: <FormattedMessage id="travel" defaultMessage={"Travel"} />,
        value: "travel"
    },
    {
        label: <FormattedMessage id="ugc" defaultMessage={"UGC"} />,
        value: "ugc"
    },
    {
        label: <FormattedMessage id="virtual_influencer" defaultMessage={"Virtual Influencer"} />,
        value: "virtual_influencer"
    },
    {
        label: <FormattedMessage id="wedding" defaultMessage={"Wedding"} />,
        value: "wedding"
    },
    {
        label: <FormattedMessage id="other" defaultMessage={"Other"} />,
        value: "other"
    },
]

export const AGENCY_CATEGORIES = [
    {
        label: <FormattedMessage id="agency" defaultMessage={"Agency"} />,
        value: "agency"
    },
    {
        label: <FormattedMessage id="e-commerce" defaultMessage={"E-commerce"} />,
        value: "e-commerce"
    },
    {
        label: <FormattedMessage id="other" defaultMessage={"Other"} />,
        value: "other"
    },
]

export const ROLE_AGENCY = {
    label: <FormattedMessage id="agency" defaultMessage={"Agency"} />,
    value: "agency"

}
export const ROLE_INFLUENCER = {
    label: <FormattedMessage id="influencer" defaultMessage={"Influencer"} />,
    value: "influencer"
}

export const ROLES = [
    ROLE_AGENCY,
    ROLE_INFLUENCER,
    ROLE_ADMIN
]


export const GENDERS = [
    {
        label: <FormattedMessage id="male" defaultMessage={"Male"} />,
        value: "male"
    },
    {
        label: <FormattedMessage id="female" defaultMessage={"Female"} />,
        value: "female"
    },
    {
        label: <FormattedMessage id="rather_not_say" defaultMessage={"Rather not say"} />,
        value: "other"
    },
]

export const INFLUENCER_TYPES = [
    {
        label: <FormattedMessage id="managed_by_me" defaultMessage={"Managed by me"} />,
        value: "agency_influencers"
    },
    {
        label: <FormattedMessage id="independent" defaultMessage={"Independent"} />,
        value: "independent_influencers"
    },
    {
        label: <FormattedMessage id="managed_by_others" defaultMessage={"Managed by others"} />,
        value: "other_agency_influencers"
    },
]






export const NUMBER_REGEX = /^[+]?\d+(-\d+)*$/ // for Phone number-> allow + sign in front and - any where between in phone numbers
// export const NUMBER_REGEX = /^[0-9]+$/

export const TELPHONE_MINIMUM_LENGTH = 10
export const TELPHONE_MAXIMUM_LENGTH = 15

export const AGENCY_INFLUENCER_STORAGE_KEY = "influencee-agency-storage-key"